import { InjectionToken } from '@angular/core';

import { MainMenu, MenuItem } from './menu-item.interface';

export const MENU_SERVICE = new InjectionToken<IMenuService>('IMenuService');

export interface IMenuService {
	/**
	 * Initialization of the menu
	 */
	init();

	/**
	 * Set's the menu prior to any processing (i.e. filtering of dev items / permission checkts etc.)
	 */
	setMenu(menu: MainMenu);

	/**
	 * Reloads the entire menu (does the processing part again)
	 */
	reload();

	/**
	 * Sets the visibility state of the menu
	 * @param isVisible Indicates whether the menu should be shown.
	 */
	setVisible(isVisible: boolean);

	/**
	 * Toggles visibility of the menu
	 */
	toggleVisibility();

	/**
	 * Updates a single menu item
	 * @param menuItemId The ID of the menu item to perform the badge update on
	 * @param newSettings New settings of the menu item
	 */
	updateMenuItem(menuItemId: MenuItem['id'], newSettings: Partial<MenuItem>);
}
